import React from 'react';
import { CalendlyButton } from '../components/common/Calendly';

const Contact: React.FC = () => {
  // Replace with your actual Calendly URL
  const calendlyUrl = 'https://calendly.com/joey-pandina';

  return (
    <div className="contact-page">
      <div className="container py-5">
        <h1 className="display-4 text-center mb-5">Contact Me</h1>
        
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="card shadow mb-5">
              <div className="card-body">
                <h2 className="card-title mb-4">Get in Touch</h2>
                <p className="card-text mb-4">
                  Have questions about my tutoring services? Want to schedule a session for your child?
                  Fill out the form below or use the contact information provided, and I'll get back to you as soon as possible.
                </p>
                
                <form>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">Name</label>
                    <input type="text" className="form-control" id="name" placeholder="Your Name" required />
                  </div>
                  
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email Address</label>
                    <input type="email" className="form-control" id="email" placeholder="your.email@example.com" required />
                  </div>
                  
                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">Phone Number</label>
                    <input type="tel" className="form-control" id="phone" placeholder="(123) 456-7890" />
                  </div>
                  
                  <div className="mb-3">
                    <label htmlFor="studentGrade" className="form-label">Student's Grade Level</label>
                    <select className="form-select" id="studentGrade">
                      <option selected disabled>Select grade level</option>
                      <option>6th Grade</option>
                      <option>7th Grade</option>
                      <option>8th Grade</option>
                      <option>9th Grade</option>
                      <option>10th Grade</option>
                      <option>11th Grade</option>
                      <option>12th Grade</option>
                    </select>
                  </div>
                  
                  <div className="mb-3">
                    <label htmlFor="subject" className="form-label">Subject Needed</label>
                    <select className="form-select" id="subject">
                      <option selected disabled>Select subject</option>
                      <option>Pre-Algebra</option>
                      <option>Algebra I</option>
                      <option>Algebra II</option>
                      <option>Geometry</option>
                      <option>Trigonometry</option>
                      <option>Pre-Calculus</option>
                      <option>Calculus</option>
                      <option>Statistics</option>
                      <option>Other</option>
                    </select>
                  </div>
                  
                  <div className="mb-3">
                    <label htmlFor="message" className="form-label">Message</label>
                    <textarea className="form-control" id="message" rows={5} placeholder="Please share any specific concerns or goals for tutoring"></textarea>
                  </div>
                  
                  <button type="submit" className="btn btn-primary">Send Message</button>
                </form>
              </div>
            </div>
            
            <div className="row">
              <div className="col-md-6 mb-4">
                <div className="card shadow h-100">
                  <div className="card-body text-center">
                    <h3 className="card-title">Schedule Directly</h3>
                    <p className="card-text">
                      You can schedule a tutoring session directly through my online booking system.
                    </p>
                    <CalendlyButton url={calendlyUrl} text="Schedule Now" className="btn btn-outline-primary" />
                  </div>
                </div>
              </div>
              
              <div className="col-md-6 mb-4">
                <div className="card shadow h-100">
                  <div className="card-body text-center">
                    <h3 className="card-title">Contact Information</h3>
                    <p className="card-text">
                      <strong>Email:</strong> joey.pandina@example.com<br />
                      <strong>Phone:</strong> (123) 456-7890
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="row mt-5">
          <div className="col-lg-8 mx-auto">
            <div className="card shadow">
              <div className="card-body">
                <h2 className="card-title mb-4">Frequently Asked Questions</h2>
                
                <div className="accordion" id="faqAccordion">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        How much do tutoring sessions cost?
                      </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                      <div className="accordion-body">
                        My tutoring rates are competitive and based on the grade level and subject complexity. Please contact me directly for specific pricing information. I offer package discounts for multiple sessions booked in advance.
                      </div>
                    </div>
                  </div>
                  
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        Where do tutoring sessions take place?
                      </button>
                    </h2>
                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
                      <div className="accordion-body">
                        I offer both online tutoring via Zoom and in-person tutoring at local libraries in the area. The choice of format depends on your preference and what works best for your child's learning style.
                      </div>
                    </div>
                  </div>
                  
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                        How long are tutoring sessions?
                      </button>
                    </h2>
                    <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
                      <div className="accordion-body">
                        Standard tutoring sessions are 60 minutes long, which I've found is the optimal time for effective learning without fatigue. I also offer 90-minute sessions for more intensive work, particularly for high school students working on advanced topics or test preparation.
                      </div>
                    </div>
                  </div>
                  
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFour">
                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                        How often should my child attend tutoring sessions?
                      </button>
                    </h2>
                    <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#faqAccordion">
                      <div className="accordion-body">
                        For most students, I recommend weekly sessions for consistent progress. For students who are significantly struggling or preparing for important exams, twice-weekly sessions may be beneficial. After an initial assessment, I can provide a more personalized recommendation based on your child's specific needs.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
